// TODO: Make an APP object that hides bsn away, for use in .js.erb files
import BSN from "bootstrap.native/dist/bootstrap-native.js";
window.bsn = BSN;
document.addEventListener("turbolinks:load",  function(){
   BSN.initCallback(document.body)
}, false)

